/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeservesPenaltyCommandResult } from '../../models/deserves-penalty-command-result';

export interface ApiKpiReportsDeservesPenaltyPost$Plain$Params {
      body?: {
'KPIId'?: string;
'DeservesPenalty'?: boolean;
}
}

export function apiKpiReportsDeservesPenaltyPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKpiReportsDeservesPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeservesPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsDeservesPenaltyPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeservesPenaltyCommandResult>;
    })
  );
}

apiKpiReportsDeservesPenaltyPost$Plain.PATH = '/api/KPIReports/DeservesPenalty';
